import React, { useEffect, useState } from 'react'

const ProfileChangePassword = ({ successIcon, failIcon, close, onUpdatePassword }) => {
  const [step, setStep] = useState('start');

  const [password, setPassword] = useState({
    current: '',
    new: '',
    error: null
  });

  const [passwordInputType, setPasswordInputType] = useState('password');

  const [isDisabledSubmit, setIsDisabledSubmit] = useState(true);

  const checkError = (e) => {
    const targetValue = e.target.value;

    if (targetValue.length < 10) {
      setPassword((prevState) => {
        return {
          ...prevState,
          error: 'Minimum 10 characters'
        }
      })
    } else if (targetValue.length >= 10) {
      setPassword((prevState) => {
        return {
          ...prevState,
          error: null
        }
      })
    }
  }

  const changeInputHandler = (e) => {
    setPassword((prevState) => {
      return {
        ...prevState,
        [e.target.id]: e.target.value
      }
    })

    checkError(e);
  }

  const showPassword = () => {
    if (passwordInputType === 'password') {
      setPasswordInputType('text');
    } else {
      setPasswordInputType('password');
    }
  }

  const checkDisabledSubmit = () => {
    if (password.current === '' || password.new === '' || password.error !== null) {
      setIsDisabledSubmit(true)
    } else setIsDisabledSubmit(false)
  }

  useEffect(() => {
    checkDisabledSubmit();
  }, [password])

  return (
    <section className='profile-change__popup'>
      {
        step === 'start' &&
        <>
          <h2 className="modal-window__title">Change Password</h2>
          <form className='profile-change__form'>
            <p className='profile-change__row'>
              <label htmlFor="current">Enter current password</label>
              <input type={passwordInputType} id='current' onInput={changeInputHandler} placeholder='Curent password' value={password.current} />
              <button className='profile-change__row-show-pass' type='button' onClick={showPassword}>
                <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
                  <path d="M13.3337 8.33333V5.83333C13.3337 3.99238 11.8413 2.5 10.0003 2.5C8.15938 2.5 6.66699 3.99238 6.66699 5.83333V8.33333M10.0003 11.6667V14.1667M4.16699 8.33333H15.8337V17.5H4.16699V8.33333Z" stroke="#ACACBB" strokeWidth="1.6" strokeLinecap="round" strokeLinejoin="round" />
                </svg>
              </button>
            </p>
            {
              password.current.length ?
                <p className='profile-change__row'>
                  <label htmlFor="new">Enter new password</label>
                  <input type="password" id='new' onInput={changeInputHandler} placeholder='New password' value={password.new} />
                </p>
                :
                null
            }
            <p className='profile-change__tip'>Minimum 10 characters</p>
            <button
              type='button'
              className='profile-change__form-submit'
              disabled={isDisabledSubmit}
              onClick={() => {
                onUpdatePassword(password.new, setStep);
              }}
            >
              Continue
            </button>
          </form>
        </>
      }

      {
        step === 'success' &&
        <>
          <header className="modal-window__header">
            <img src={successIcon} className="modal-window__icon" alt="" />
            <h5 className="modal-window__title">Success!</h5>
            <p className="modal-window__info">Your password has been updated successfully!</p>
          </header>
          <footer className="modal-window__footer">
            <button className="modal-window__footer-submit" onClick={close}>Done</button>
          </footer>
        </>
      }

      {
        step === 'fail' &&
        <>
          <header className="modal-window__header">
            <img src={failIcon} className="modal-window__icon" alt="" />
            <h5 className="modal-window__title">Oops...</h5>
            <p className="modal-window__info">Your password has not been changed</p>
          </header>
          <footer className="modal-window__footer">
            <button className="modal-window__footer-submit" onClick={close}>Done</button>
          </footer>
        </>
      }
    </section>
  )
}

export default ProfileChangePassword;
